const SelectTheme = {
  parts: ["field", "icon"],

  baseStyle: {
    field: {
      fontFamily: "'Inter', sans-serif",
      fontSize: "14px",
      lineHeight: "24px",
      color: "#222222",
      backgroundColor: "#F3F3F5",
      border: "1px solid #E6E8EE",
      borderRadius: "10px",
      paddingInline: "12px",
      height: "36px",
      transition: "all 0.2s ease",

      _placeholder: {
        color: "#999999",
      },
      _hover: {
        borderColor: "#666666",
      },
      _focus: {
        borderColor: "#666666",
        boxShadow: "0 0 0 1px #666666",
      },
    },
    icon: {
      color: "#666666",
    },
  },

  defaultProps: {
    size: "sm",
    variant: "outline",
  },
};

export default SelectTheme;
